import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class MailTemplate extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, partnerId, key }) {
        if (!organizationId || !key) {
            throw new ArgumentError(`[Model][MailTemplate] organizationId and keyId are mandatory`);
        }

        if (partnerId) {
            return `/ticket/organizations/${organizationId}/partners/${partnerId}/mailing/templates/${key}`;
        }

        return `/ticket/organizations/${organizationId}/mailing/templates/${key}`;
    }
}
